type ConcatValue<T> = T | ArrayLike<T> | null | undefined | false;

// ----------------------------------------------------------------------------

function isArrayLike<T>(value: unknown): value is ArrayLike<T> {
    if (value == null || typeof value === 'function' || typeof value === 'string') {
        return false;
    }

    return typeof (value as ArrayLike<T>).length === 'number';
}

function concat<T>(...args: [boolean, ...ConcatValue<T>[]] | ConcatValue<T>[]): T[] {
    const allowFalsy = args[0] === true;
    const startIndex = allowFalsy ? 1 : 0;

    const list: T[] = [];

    for (let i = startIndex; i < args.length; i++) {
        const item = args[i] as ConcatValue<T>;

        if (!allowFalsy && (item == null || item === false)) {
            continue;
        }

        if (Array.isArray(item) || isArrayLike<T>(item)) {
            for (const element of Array.from(item)) {
                list.push(element);
            }
        } else {
            list.push(item as T);
        }
    }

    return list;
}

// ----------------------------------------------------------------------------

export default concat;
